import { createTheme } from "@material-ui/core/styles";

export const getTheme = (mode = "light") =>
  createTheme({
    palette: {
      type: mode,
      primary: {
        main: "#1A2819",
      },
      secondary: {
        main: "#866F3E",
      },
      background: {
        default: mode === "dark" ? "#121212" : "#fff",
        paper: mode === "dark" ? "#1e1e1e" : "#f5f5f5",
      },
    },
    typography: {
      fontFamily: `"AvenirLTProBook", "sans-serif"`,
      allVariants: {
        color: "var(--foreground)",
      },
    },
    overrides: {
      MuiInputLabel: {
        root: {
          color: "var(--muted-text)",
          "&$focused": {
            color: "var(--foreground)",
          },
        },
      },
      MuiOutlinedInput: {
        root: {
          "& $notchedOutline": {
            borderColor: "var(--muted-text)",
          },
          "&:hover $notchedOutline": {
            borderColor: "var(--foreground)",
          },
          "&$focused $notchedOutline": {
            borderColor: "var(--foreground)",
          },
          color: "var(--foreground)"
        },
      },
      MuiFormLabel: {
        root: {
          color: "var(--muted-text)",
          "&$focused": {
            color: "var(--foreground)",
          },
        },
      },
    },
  });
